import cx from 'classnames';
import { useIntl } from 'gatsby-plugin-intl';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { DOCUMENTS_TYPES, chunk, documentPropTypes } from '../../utils';
import FlagLinkColumn from '../FlagLink/FlagLinkColumn';
import styles from './Documents.module.scss';

export const Documents = ({ data }) => {
	const intl = useIntl();
	const [activeTab, setActiveTab] = useState(DOCUMENTS_TYPES.direct);

	const tabs = [
		{ key: DOCUMENTS_TYPES.direct, text: intl.formatMessage({ id: 'nav.documents_direct' }) },
		{ key: DOCUMENTS_TYPES.indirect, text: intl.formatMessage({ id: 'nav.documents_indirect' }) },
	];

	const renderColumn = (column, index) => (
		<FlagLinkColumn
			key={index}
			data={column.map(item => ({
				title: item.country.code,
				countryName: item.country.name,
				flag: item.country.flag,
				url: item.url,
			}))}
		/>
	);

	const renderTabs = () => {
		return tabs.map(tab => (
			<span key={tab.key} className={cx(tab.key === activeTab && styles.active)} onClick={() => setActiveTab(tab.key)}>
				{tab.text}
			</span>
		));
	};
	return (
		<div className={styles.container}>
			<section className={styles.tabs}>{renderTabs()}</section>
			<section className={styles.flags}>{chunk(data[activeTab]).map(renderColumn)}</section>
		</div>
	);
};

Documents.propTypes = {
	data: PropTypes.shape({
		direct: PropTypes.arrayOf(documentPropTypes),
		indirect: PropTypes.arrayOf(documentPropTypes),
	}),
};
